import { get } from 'svelte/store';
import { changeToken } from '../../../../Api.js';
import { api } from '../../../../helpers/index.js';
import { getTags, searchPublications } from '../../../custom/GlobalSearch/services/index.js';
import { activeTags, flowId, globalSearch, groups, isShowSearchLoader, list, ordering, pagination, tags } from '../../../stores';
import { fixedNews, scrolledPublicationId, selectedGroup, } from '../store';
import { tick } from 'svelte';
const getOrderingGroup = () => {
    const group = get(selectedGroup);
    return (group === null || group === void 0 ? void 0 : group.slug) === 'physical_transformation' ? 'feed' : 'rpp';
};
export const getFixedNews = async () => {
    const group = get(selectedGroup);
    if (!group) {
        return;
    }
    let path = '/api/v1/publication/feed/fix-list/?';
    const idFlow = get(flowId);
    const tags = get(activeTags);
    for (let tag of tags) {
        if (tags.length) {
            path += `&feed_tags=${tag}`;
        }
    }
    if (idFlow) {
        path += `&flows=${idFlow}`;
    }
    path += `&feed_group=${group.slug}`;
    const response = await api(path);
    if (!response.ok) {
        changeToken(response.status);
        return;
    }
    const data = await response.json();
    fixedNews.set(data);
};
export const getGroups = async () => {
    const response = await api('/api/v1/feed/filters/list/');
    const data = await response.json();
    groups.set(data.group);
    if (!data.group.length) {
        selectedGroup.set(null);
        return;
    }
    const currentTab = JSON.parse(localStorage.getItem('currentTab'));
    if (currentTab && data.group.find((group) => group.slug === currentTab.slug)) {
        selectedGroup.set(currentTab);
    }
    else {
        selectedGroup.set(data.group[0]);
    }
};
export const clearAndGetNews = async () => {
    if (!get(selectedGroup)) {
        return;
    }
    isShowSearchLoader.set(true);
    list.set([]);
    fixedNews.set([]);
    await Promise.all([
        searchPublications({
            orderingGroup: getOrderingGroup()
        }),
        getFixedNews()
    ]);
    isShowSearchLoader.set(false);
};
const filterNewsByFlow = async ({ id }) => {
    if (!get(selectedGroup)) {
        return;
    }
    isShowSearchLoader.set(true);
    flowId.set(id);
    list.set([]);
    fixedNews.set([]);
    await Promise.all([
        searchPublications({
            orderingGroup: getOrderingGroup()
        }),
        getFixedNews(),
    ]);
    isShowSearchLoader.set(false);
};
const filterNewsByOrdering = (option) => {
    ordering.set(option.value);
    clearAndGetNews();
};
export const filterNews = ({ detail: { type, option } }) => {
    if (type === 'ordering') {
        filterNewsByOrdering(option);
    }
    if (type === 'flow') {
        filterNewsByFlow(option);
    }
};
export const infiniteScrollHandler = async () => {
    const group = get(selectedGroup);
    if (!group) {
        return;
    }
    isShowSearchLoader.set(true);
    await searchPublications({
        page: get(pagination).next_page_number,
        orderingGroup: getOrderingGroup(),
        feedGroup: group.slug
    });
    isShowSearchLoader.set(false);
};
export const startTabsLoading = () => {
    isShowSearchLoader.set(true);
};
export const endTabsLoading = () => {
    isShowSearchLoader.set(false);
};
export const initNewsline = async () => {
    // resetSearch()
    if (!get(groups).length) {
        await getGroups();
    }
    const group = get(selectedGroup);
    if (!group) {
        isShowSearchLoader.set(false);
        return;
    }
    if (!get(fixedNews).length && !get(globalSearch).length) {
        await getFixedNews();
    }
    if (!get(list).length) {
        await searchPublications({
            orderingGroup: getOrderingGroup(),
            feedGroup: group.slug,
        });
    }
    if (!get(tags).length) {
        await getTags();
    }
    isShowSearchLoader.set(false);
    await tick();
    const publication = document.getElementById(get(scrolledPublicationId));
    if (publication) {
        publication.scrollIntoView({ block: 'center' });
    }
};
